export enum FeedbackStatusType {
  PUBLIC = "public",
  DRAFT = "draft",
}
